import download from 'downloadjs';
import history from '_helpers/history';
import store from '_helpers/store';
import alertActions from '_actions/alert.actions';

export const RESPONSE_TYPES = {
  JSON: 10,
  FILE_DOWNLOAD: 20,
};

const processContent = (contentType, response) => {
  if (!contentType) {
    return null;
  }

  if (contentType.includes('application/json') || contentType.includes('application/problem+json')) {
    return response.json();
  } if (contentType.includes('text/plain')) {
    return response.text();
  }
  return null;
};

const errorMessage = (errResp) => {
  if (typeof errResp === 'string' || errResp instanceof String) {
    return errResp;
  } if (errResp?.detail || typeof errResp?.detail === 'string') {
    return errResp?.detail;
  }

  return null;
};

const handleResponseAsync = async (response, type = RESPONSE_TYPES.JSON) => {
  const contentType = response.headers.get('content-type')?.toLowerCase();
  if (response.ok) {
    // Check if it has an attachment that we should download for the user
    if (type === RESPONSE_TYPES.FILE_DOWNLOAD) {
      let filename = '';
      const contentdisposition = response.headers.get('content-disposition');

      if (contentdisposition && contentdisposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentdisposition);

        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }

      if (contentType) {
        const blob = await response.blob();
        download(blob, filename, contentType);

        return true;
      }

      return null;
    }

    return processContent(contentType, response);
  }

  const errResp = await processContent(contentType, response);

  // Taken from session.js > checkSession
  if (errResp === 'Session expired') {
    history.push('/login');
  }

  switch (response.status) {
    case 401:
      store.dispatch(alertActions.error(errorMessage(errResp) || 'Access denied.'));
      break;
    case 403:
      store.dispatch(alertActions.error(errorMessage(errResp) || 'Access denied.'));
      break;
    case 404:
      store.dispatch(alertActions.error(errorMessage(errResp) || 'Not found.'));
      break;
    case 409:
      store.dispatch(alertActions.error(errorMessage(errResp) || 'Information coflict occured on server.'));
      break;
    case 400:
      store.dispatch(alertActions.error(errorMessage(errResp) || 'Bad request.'));
      break;
    default:
      store.dispatch(alertActions.error(errorMessage(errResp) || 'An error has occurred.'));
      break;
  }

  return errResp;
};

// NOTE: We will merge this all into one once we've fixed up the rest of the services
function handleResponse(response) {
  return new Promise((resolve, reject) => {
    if (response.ok) {
      // return json if it was returned in the response
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        response.json().then((json) => resolve(json));
      } else {
        resolve();
      }
    } else {
      // NOTE: Validate that the expired session is being handled by the Identity Service
      /*if (response.status === 401 || response.status === 403) {
        session.isSessionExpired(reject);
      }*/
      // return error message from response body
      response.text().then((text) => reject(new Error(text)));
      if (response.status === 404) {
        history.push('/404');
      } if (response.status === 401) {
        history.push('/401');
      } if (response.status === 500) {
        history.push('/500');
      }
    }
  });
}

function handleFileResponse(response) {
  return new Promise((resolve, reject) => {
    if (response.ok) {
      // return json if it was returned in the response
      const contentType = response.headers.get('content-type');
      const contentdisposition = response.headers.get('content-disposition');
      let filename = '';
      if (contentdisposition && contentdisposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentdisposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }
      if (contentType) {
        response.blob().then((blob) => {
          download(blob, filename, contentType);
          resolve();
        });
      } else {
        resolve();
      }
    } else {
      /*if (response.status === 401 || response.status === 403) {
        isSessionExpired(reject);
      }*/
      // return error message from response body
      response.text().then((text) => reject(new Error(text)));

      if (response.status === 404) {
        history.push('/404');
      } else if (response.status === 401) {
        history.push('/401');
      }
    }
  });
}

function handleError(error) {
  return Promise.reject(error && error.message);
}

export default {
  handleResponse,
  handleFileResponse,
  handleError,
  handleResponseAsync,
};
